export default __webpack_public_path__ + "static/media/Logo.c4f21d00.png";